module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_6005.c32e968d.png";